import { Injectable, OnDestroy, OnInit } from "@angular/core";
import { Subject, BehaviorSubject, fromEvent } from "rxjs";
import { takeUntil, debounceTime } from "rxjs/operators";
import { Router } from "@angular/router";
import { DataStorageService } from "./data-storage.service";
import { CommonService } from "./common-service.service";

// Menu
export interface Menu {
  headTitle1?: string;
  headTitle2?: string;
  path?: string;
  title?: string;
  icon?: string;
  type?: string;
  badgeType?: string;
  badgeValue?: string;
  active?: boolean;
  bookmark?: boolean;
  children?: Menu[];
}

@Injectable({
  providedIn: "root",
})
export class NavService implements OnInit, OnDestroy {
  private unsubscriber: Subject<any> = new Subject();
  public screenWidth: BehaviorSubject<number> = new BehaviorSubject(
    window.innerWidth
  );

  // Search Box
  public search: boolean = false;

  // Language
  public language: boolean = false;

  // Mega Menu
  public megaMenu: boolean = false;
  public levelMenu: boolean = false;
  public megaMenuColapse: boolean = window.innerWidth < 1199 ? true : false;

  // Collapse Sidebar
  public collapseSidebar: boolean = window.innerWidth < 991 ? true : false;

  // For Horizontal Layout Mobile
  public horizontal: boolean = window.innerWidth < 991 ? false : true;

  // Full screen
  public fullScreen: boolean = false;
  public menuTestJson = [];
  //   MENUITEMS = [];
  UserID = 96622;
  constructor(
    private router: Router,
    private api: DataStorageService,
    private commonService: CommonService
  ) {
    this.setScreenWidth(window.innerWidth);
    fromEvent(window, "resize")
      .pipe(debounceTime(1000), takeUntil(this.unsubscriber))
      .subscribe((evt: any) => {
        this.setScreenWidth(evt.target.innerWidth);
        if (evt.target.innerWidth < 991) {
          this.collapseSidebar = true;
          this.megaMenu = false;
          this.levelMenu = false;
        }
        if (evt.target.innerWidth < 1199) {
          this.megaMenuColapse = true;
        }
      });
    if (window.innerWidth < 991) {
      // Detect Route change sidebar close
      this.router.events.subscribe((event) => {
        this.collapseSidebar = true;
        this.megaMenu = false;
        this.levelMenu = false;
      });
    }

    this.getMenu();
  }

  async getMenu() {
    //debugger
    let UserID = localStorage.getItem("UserID");
    // console.log("UserID="+UserID)
    await this.api
      .getData("Master/GetMenuList/" + parseInt(UserID) + "/22")
      .subscribe((res: any) => {
        let list = JSON.parse(JSON.parse(res).Response);
        list.forEach((row) => {
          row.menuItems.forEach(row1 => {
            this.menuTestJson.push({
              path: row1.UI_URL,
              icon: "framer",
              title: row1.MENU_NAME,
              type: "link",
            });
          })

        });
      });
  }
  ngOnDestroy() {
    this.unsubscriber.next();
    this.unsubscriber.complete();
  }

  ngOnInit(): void { }

  private setScreenWidth(width: number): void {
    this.screenWidth.next(width);
  }
  // MENUITEMS: Menu[] = [];
  MENUITEMS1: Menu[] = [
  ];

  MEGAMENUITEMS: Menu[] = [
  ];

  LEVELMENUITEMS: Menu[] = [
  ];

  items = new BehaviorSubject<Menu[]>(this.menuTestJson);
  megaItems = new BehaviorSubject<Menu[]>(this.MEGAMENUITEMS);
  levelmenuitems = new BehaviorSubject<Menu[]>(this.LEVELMENUITEMS);
}
